import { reset } from 'redux-form';

import { TYPE_ERROR } from '@eventbrite/eds-notification';

import { postRefundRequest } from '../api';

import { REFUND_REQUESTS_FORM } from '../constants';

import { getHelpLinks } from '../selectors';

export const DISABLE_SUBMIT_BUTTON = 'disableSubmitButton';
export const disableSubmitButton = (disable) => ({
    type: DISABLE_SUBMIT_BUTTON,
    payload: disable,
});
export const SHOW_REFUND_NOTIFICATION = 'showRefundNotification';
export const showRefundNotification = ({ message, type }) => ({
    type: SHOW_REFUND_NOTIFICATION,
    payload: {
        message,
        type,
    },
});
export const CLEAR_REFUND_NOTIFICATION = 'clearRefundNotification';
export const clearRefundNotification = () => ({
    type: CLEAR_REFUND_NOTIFICATION,
});
export const HIDE_CAPTCHA = 'hideCaptcha';
export const hideCaptcha = (hide = false) => ({
    type: HIDE_CAPTCHA,
    payload: hide,
});

export const createRefundRequest =
    ({ attendeeEmail, orderId, additionalInformation, captcha }) =>
    (dispatch, getState) => {
        dispatch(disableSubmitButton(true));
        dispatch(hideCaptcha(true));

        const helpLinks = getHelpLinks(getState());

        postRefundRequest({
            attendeeEmail,
            orderId,
            additionalInformation,
            captcha,
            helpLinks,
        })
            .then(async ({ message, type }) => {
                dispatch(
                    showRefundNotification({
                        message: message,
                        type: type,
                    }),
                );
                dispatch(reset(REFUND_REQUESTS_FORM));
            })
            .catch((err) => {
                dispatch(
                    showRefundNotification({
                        message: err.errors._error,
                        type: TYPE_ERROR,
                    }),
                );
            })
            .finally(() => {
                dispatch(disableSubmitButton(false));
                dispatch(hideCaptcha());
            });
    };
